import { useSelector } from 'react-redux';
import { isDefined } from '../utils';

export default function useAssignmentsToUnassign() {
  const assignmentsToUnassign = useSelector(
    (state) =>
      (state.CourseAssignReducer.assignments.studentAssignments &&
        state.CourseAssignReducer.assignments.studentAssignments.filter(
          (assignment) =>
            assignment.isSelected &&
            assignment.assignment &&
            isDefined(assignment.assignment.assignStatus)
        )) ||
      []
  );
  return assignmentsToUnassign;
}



// WEBPACK FOOTER //
// ./helpers/hooks/use-assignment-to-unassign.js